<template>
  <v-row>
    <v-col :sm="hasPnValues ? 6 : 12">
      <v-text-field
          v-model="textValue"
          :label="label"
          :maxlength="maxlength"
          type="text"
          :disabled="!!pnValue"
          @keypress="validate"
      />
    </v-col>
    <v-col
      v-if="hasPnValues"
      sm="6"
    >
      <v-autocomplete
          v-model="pnValue"
          label="Pertinent Negatives"
          :items="selectPnItems"
          clearable
      />
    </v-col>
  </v-row>
</template>
<script>
import _ from 'lodash';

export default {
  name: 'DbpPn',
  props: {
    value: {
      type: [String, Number],
    },
    pn: {
      type: String,
    },
    label: {
      type: String,
    },
    field: {
      type: Object,
      required: true,
    },
  },

  computed: {
    hasPnValues() {
      return !_.isEmpty(this.field.pnValues);
    },
    selectPnItems() {
      if (!this.field.pnValues) {
        return null;
      }
      return _.map(this.field.pnValues, (text, code) => ({
        text,
        value: code,
      }));
    },
    textValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    pnValue: {
      get() {
        return this.pn;
      },
      set(value) {
        this.$emit('update:pn', value);
        if (value) {
          this.$emit('input', null);
        }
      },
    },
    maxlength() {
      if (this.field.restrictions && this.field.restrictions.maxlen) {
        return this.field.restrictions.maxlen;
      }
      if (this.field.restrictions && this.field.restrictions.max) {
        return this.field.restrictions.max.toString().length;
      }
      return 255;
    },
  },
  methods: {
    validate($event) {
      const { key } = $event;
      const value = this.textValue.toString();

      // Allowed cases
      const isDigit = /^[0-9]$/.test(key);
      const isP = key === 'P' || key === 'p';

      // Handle digits
      if (isDigit) {
        // Block if already 3 digits
        if (value.length >= 3) {
          $event.preventDefault();
          return;
        }
        // Block digits if P exists
        if (/p/i.test(value)) {
          $event.preventDefault();
          return;
        }
        return; // allow digit
      }

      // Handle P/p
      if (isP) {
        // Block P if digits exist
        if (/[0-9]/.test(value)) {
          $event.preventDefault();
          return;
        }
        // Block P if already present
        if (/p/i.test(value)) {
          $event.preventDefault();
          return;
        }
        return; // allow P
      }

      // Block any other characters
      $event.preventDefault();
    },
  },
};
</script>
